import React, {useEffect, useRef} from 'react';
import {useTranslation} from 'react-i18next';
import * as R from 'ramda';
import {select as d3$} from 'd3';
import {donut} from 'britecharts';

import {codeMapping} from '@/config';
import {lookup} from '@/i18n';
import CategoryList from '@/b2c/MyPlan/CategoryList';

const paint = (data, target) => {
  const container = d3$(target);

  if (!data.length) {
    return;
  }

  // instead of skip, we should re-write the chart as the language is changed
  if (container.select('svg').node()) {
    container.select('svg').remove();
  }

  const bgcolors = R.map(R.prop('bgColor'), data);
  container.datum(data);

  const donutChart = donut()
    .highlightSliceById(1)
    .width(370)
    .height(370)
    .colorSchema(bgcolors)
    .centeredTextFunction(({quantity, name}) => `${quantity} ${name}`)
    .externalRadius(150)
    .internalRadius(90)
    .hasFixedHighlightedSlice(true)
    .on('customMouseOut', slice => {
      // FIXME: it always highlight first slice
      donutChart.highlightSliceById(slice.data.id);
    });

  container.call(donutChart);
  container
    .select('.legend-group')
    .insert('circle', '.donut-text')
    .attr('r', 100)
    .style('fill', '#000')
    .style('opacity', '.1');
  container
    .select('.legend-group')
    .insert('circle', '.donut-text')
    .attr('r', 90)
    .style('fill', '#fff');
};

const PlanChart = ({plans}) => {
  const categoryColorMap = codeMapping('plan_record_type_color');
  const canvas = useRef(null);
  const {t: tr} = useTranslation('myPlan');

  const categories = R.compose(
    R.addIndex(R.map)(([key, items], idx) => ({
      id: idx + 1,
      name: lookup('product_type', key),
      quantity: items.length,
      bgColor: categoryColorMap[key],
    })),
    R.toPairs,
    R.groupBy(R.prop('productCategory'))
  )(plans);

  useEffect(
    () => {
      paint(categories, canvas.current);
    },
    [categories]
  );

  const middle = Math.max(Math.ceil(categories.length / 2), 3);
  const [left, right] = [categories.slice(0, middle), categories.slice(middle)];

  return (
    <div className='myPortfolio-chart'>
      <div className='row'>
        <div className='col-xl-4 col-md-3 left wide'>
          <ul className='items'>
            <CategoryList categories={left} />
          </ul>
        </div>
        <div className='col-xl-4 col-md-6 col-sm-12 chart-container'>
          <h1>{tr('title')}</h1>
          <div ref={canvas} />
        </div>
        <div className='col-xl-4 col-md-3 right wide'>
          <ul className='items'>
            <CategoryList categories={right} />
          </ul>
        </div>
      </div>
    </div>
  );
};

export default PlanChart;
